import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues, FormControlProperties } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';
import { TableDefinition } from '@reporting/rp-types/mdm';
import { TableTypes } from '../types';

export class TableDefFormAdapter extends FormAdapter {

	constructor(
		private table: TableDefinition,
		public path: string = null
	) { super() }

	getColumns() {
		return [
			{ width: 250 },
			{ width: null },
		];
	}

	async getControls() {
		let folder: string;
		let name: string;
		if(this.table.md_name || this.path) {
			const nameArray = (this.table.md_name ? this.table.md_name.split('/') : this.path.split('/')) || [];
			name = nameArray.pop();
			folder = nameArray.join('/');
			if (folder) folder += '/';
		}
		const controls: FormControlProperties[] = [
			{ row: 0, col: 0, type: FormControlType.Label, value: msg('Folder'), for: 'folder' },
			{ row: 0, col: 1, type: FormControlType.TextInput, key: 'folder', value: folder || null },
			{ row: 1, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name' },
			{ row: 1, col: 1, type: FormControlType.TextInput, key: 'name', required: true, value: name || null },
			{ row: 2, col: 0, type: FormControlType.Label, value: msg('Synchronization'), for: 'sync' },
			{ row: 2, col: 1, type: FormControlType.Checkbox, key: 'sync', value: this.table.sync || false }
		];
		if (this.table.type === TableTypes.MDM) {
			controls.push(
				{ row: 3, col: 0, type: FormControlType.Label, value: msg('Lockable rows'), for: 'lockable' },
				{ row: 3, col: 1, type: FormControlType.Checkbox, key: 'lockable', value: this.table.lockable || false},
				{ row: 4, col: 0, type: FormControlType.Label, value: `${msg('Show column')} 'HIDDEN'`, for: 'show_hidden' },
				{ row: 4, col: 1, type: FormControlType.Checkbox, key: 'show_hidden', value: this.table.show_hidden || false},
				{ row: 5, col: 0, type: FormControlType.Label, value: `${msg('Show column')} 'WHO_CREATED'`, for: 'show_who_created' },
				{ row: 5, col: 1, type: FormControlType.Checkbox, key: 'show_who_created', value: this.table.show_who_created || false},
				{ row: 6, col: 0, type: FormControlType.Label, value: `${msg('Show column')} 'DATE_CREATED'`, for: 'show_date_created' },
				{ row: 6, col: 1, type: FormControlType.Checkbox, key: 'show_date_created', value: this.table.show_date_created || false},
			);
		}
		return controls;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		let folder: string = formValues.folder ? formValues.folder as string : '';
		if(folder && folder[folder.length - 1] !== '/') folder += '/';
		this.table.md_name = `${folder}${formValues.name}`;
		this.table.sync = formValues.sync as boolean;
		if (this.table.type === TableTypes.MDM) {
			this.table.lockable = formValues.lockable as boolean;
			this.table.show_hidden = formValues.show_hidden as boolean;
			this.table.show_who_created = formValues.show_who_created as boolean;
			this.table.show_date_created = formValues.show_date_created as boolean;
		}
		await rp.ms('mdm').post(`tableDefinitions`, this.table)
		return true;
	}

};
